// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_CodePoint_Unicode from "../Data.CodePoint.Unicode/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing_Combinators from "../Parsing.Combinators/index.js";
import * as Parsing_String from "../Parsing.String/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Time_Component.eqHour);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Time_Component.eqMinute);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Data_DateTime.eqDateTime);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var toEnum = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumSecond);
var toEnum1 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMillisecond);
var toEnum2 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumHour);
var toEnum3 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMinute);
var diff = /* #__PURE__ */ Data_Time.diff(Data_Time_Duration.durationMilliseconds);
var adjust = /* #__PURE__ */ Data_DateTime.adjust(Data_Time_Duration.durationMilliseconds);
var negateDuration = /* #__PURE__ */ Data_Time_Duration.negateDuration(Data_Time_Duration.durationMilliseconds);
var show = /* #__PURE__ */ Data_Show.show(Data_Time_Component.showHour);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Time_Component.showMinute);
var show2 = /* #__PURE__ */ Data_Show.show(Data_DateTime.showDateTime);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Parsing.bindParserT);
var choice = /* #__PURE__ */ Parsing_Combinators.choice(Data_Foldable.foldableArray);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Parsing.applicativeParserT);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_List_Types.foldableList)(Data_Monoid.monoidArray);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Parsing.applicativeParserT);
var Plus = /* #__PURE__ */ (function () {
    function Plus() {

    };
    Plus.value = new Plus();
    return Plus;
})();
var Minus = /* #__PURE__ */ (function () {
    function Minus() {

    };
    Minus.value = new Minus();
    return Minus;
})();
var Zulu = /* #__PURE__ */ (function () {
    function Zulu() {

    };
    Zulu.value = new Zulu();
    return Zulu;
})();
var Offset = /* #__PURE__ */ (function () {
    function Offset(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Offset.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Offset(value0, value1, value2);
            };
        };
    };
    return Offset;
})();
var FullDateTime = /* #__PURE__ */ (function () {
    function FullDateTime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    FullDateTime.create = function (value0) {
        return function (value1) {
            return new FullDateTime(value0, value1);
        };
    };
    return FullDateTime;
})();
var eqDirection = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Plus && y instanceof Plus) {
                return true;
            };
            if (x instanceof Minus && y instanceof Minus) {
                return true;
            };
            return false;
        };
    }
};
var eq3 = /* #__PURE__ */ Data_Eq.eq(eqDirection);
var eqOffset = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Zulu && y instanceof Zulu) {
                return true;
            };
            if (x instanceof Offset && y instanceof Offset) {
                return eq3(x.value0)(y.value0) && eq(x.value1)(y.value1) && eq1(x.value2)(y.value2);
            };
            return false;
        };
    }
};
var eq4 = /* #__PURE__ */ Data_Eq.eq(eqOffset);
var eqFullDateTime = {
    eq: function (x) {
        return function (y) {
            return eq2(x.value0)(y.value0) && eq4(x.value1)(y.value1);
        };
    }
};
var toUTC = function (v) {
    if (v.value1 instanceof Zulu) {
        return pure(v.value0);
    };
    if (v.value1 instanceof Offset) {
        return bind(apply(apply(apply(map(Data_Time.Time.create)(pure(v.value1.value1)))(pure(v.value1.value2)))(toEnum(0)))(toEnum1(0)))(function (offsetTime) {
            return bind(apply(apply(apply(map(Data_Time.Time.create)(toEnum2(0)))(toEnum3(0)))(toEnum(0)))(toEnum1(0)))(function (zeroTime) {
                var duration = diff(zeroTime)(offsetTime);
                if (v.value1.value0 instanceof Plus) {
                    return adjust(duration)(v.value0);
                };
                if (v.value1.value0 instanceof Minus) {
                    return adjust(negateDuration(duration))(v.value0);
                };
                throw new Error("Failed pattern match at Data.DateTime.Parsing (line 185, column 3 - line 187, column 56): " + [ v.value1.value0.constructor.name ]);
            });
        });
    };
    throw new Error("Failed pattern match at Data.DateTime.Parsing (line 178, column 1 - line 178, column 43): " + [ v.constructor.name ]);
};
var showDirection = {
    show: function (v) {
        if (v instanceof Plus) {
            return "+";
        };
        if (v instanceof Minus) {
            return "-";
        };
        throw new Error("Failed pattern match at Data.DateTime.Parsing (line 44, column 1 - line 46, column 19): " + [ v.constructor.name ]);
    }
};
var show3 = /* #__PURE__ */ Data_Show.show(showDirection);
var showOffset = {
    show: function (v) {
        if (v instanceof Zulu) {
            return "(Offset Zulu)";
        };
        if (v instanceof Offset) {
            return "(Offset " + (show3(v.value0) + (" " + (show(v.value1) + (":" + (show1(v.value2) + ")")))));
        };
        throw new Error("Failed pattern match at Data.DateTime.Parsing (line 35, column 1 - line 37, column 86): " + [ v.constructor.name ]);
    }
};
var show4 = /* #__PURE__ */ Data_Show.show(showOffset);
var showFullDateTime = {
    show: function (v) {
        return "(FullDateTime " + (show2(v.value0) + (" " + (show4(v.value1) + ")")));
    }
};
var parseZuluOffset = function (dictMonad) {
    return bind1(choice([ Parsing_String["char"]("Z"), Parsing_String["char"]("z") ]))(function () {
        return pure1(Zulu.value);
    });
};
var parseDirection = function (dictMonad) {
    return bind1(choice([ Parsing_String["char"]("+"), Parsing_String["char"]("-") ]))(function (direction) {
        if (direction === "+") {
            return pure1(Plus.value);
        };
        if (direction === "-") {
            return pure1(Minus.value);
        };
        return Parsing.fail("Bad direction");
    });
};
var maybeFail = function (dictMonad) {
    return function (str) {
        return Data_Maybe.maybe(Parsing.fail(str))(pure1);
    };
};
var digit = function (dictMonad) {
    return Parsing_String.satisfy(function ($146) {
        return Data_CodePoint_Unicode.isDecDigit(Data_String_CodePoints.codePointFromChar($146));
    });
};
var parseSecondFraction = function (dictMonad) {
    var digit1 = digit(dictMonad);
    var maybeFail1 = maybeFail(dictMonad);
    return bind1(Parsing_String["char"]("."))(function () {
        return bind1(Parsing_Combinators.many1(digit1))(function (digits) {
            var arrayOfDigits = Data_Array.concat((function (x) {
                return [ [ "0", "." ], x ];
            })(Data_Array.take(3)(foldMap(Data_Array.singleton)(Data_List_Types.toList(digits)))));
            var maybeN = Data_Number.fromString(Data_String_CodeUnits.fromCharArray(arrayOfDigits));
            var millisecond = bind(maybeN)(function (n) {
                return toEnum1(Data_Int.floor(n * 1000.0));
            });
            return maybeFail1("bad millisecond")(millisecond);
        });
    });
};
var count = function (dictMonad) {
    return function (n) {
        return function (p) {
            return sequence(Data_Array.replicate(n)(p));
        };
    };
};
var parseDigits = function (dictMonad) {
    var count1 = count(dictMonad);
    var digit1 = digit(dictMonad);
    return function (n) {
        return bind1(count1(n)(digit1))(function (digits) {
            return Data_Maybe.maybe(Parsing.fail("bad number"))(function ($147) {
                return pure1(Data_Int.floor($147));
            })(Data_Number.fromString(Data_String_CodeUnits.fromCharArray(digits)));
        });
    };
};
var parseDateTimeSegment = function (dictMonad) {
    var parseDigits1 = parseDigits(dictMonad);
    var maybeFail1 = maybeFail(dictMonad);
    return function (dictBoundedEnum) {
        var toEnum4 = Data_Enum.toEnum(dictBoundedEnum);
        return function (errorMessage) {
            return function (n) {
                return bind1(parseDigits1(n))(function (digits) {
                    return maybeFail1(errorMessage)(toEnum4(digits));
                });
            };
        };
    };
};
var parseDay = function (dictMonad) {
    return parseDateTimeSegment(dictMonad)(Data_Date_Component.boundedEnumDay)("bad day")(2);
};
var parseHour = function (dictMonad) {
    return parseDateTimeSegment(dictMonad)(Data_Time_Component.boundedEnumHour)("bad hour")(2);
};
var parseMinute = function (dictMonad) {
    return parseDateTimeSegment(dictMonad)(Data_Time_Component.boundedEnumMinute)("bad minute")(2);
};
var parseNumOffset = function (dictMonad) {
    var parseHour1 = parseHour(dictMonad);
    var parseMinute1 = parseMinute(dictMonad);
    return bind1(parseDirection(dictMonad))(function (direction) {
        return bind1(parseHour1)(function (hour) {
            return bind1(Parsing_String["char"](":"))(function () {
                return bind1(parseMinute1)(function (minute) {
                    return pure1(new Offset(direction, hour, minute));
                });
            });
        });
    });
};
var parseOffset = function (dictMonad) {
    return choice([ parseZuluOffset(dictMonad), parseNumOffset(dictMonad) ]);
};
var parseMonth = function (dictMonad) {
    return parseDateTimeSegment(dictMonad)(Data_Date_Component.boundedEnumMonth)("bad month")(2);
};
var parseSecond = function (dictMonad) {
    return parseDateTimeSegment(dictMonad)(Data_Time_Component.boundedEnumSecond)("bad second")(2);
};
var parsePartialTime = function (dictMonad) {
    var parseMinute1 = parseMinute(dictMonad);
    var parseSecond1 = parseSecond(dictMonad);
    var maybeFail1 = maybeFail(dictMonad);
    var parseSecondFraction1 = parseSecondFraction(dictMonad);
    return bind1(parseHour(dictMonad))(function (hh) {
        return bind1(Parsing_String["char"](":"))(function () {
            return bind1(parseMinute1)(function (mm) {
                return bind1(Parsing_String["char"](":"))(function () {
                    return bind1(parseSecond1)(function (ss) {
                        return bind1(maybeFail1("bad default millisecond")(toEnum1(0)))(function (default_mss) {
                            return bind1(Parsing_Combinators.option(default_mss)(parseSecondFraction1))(function (mss) {
                                return pure1(new Data_Time.Time(hh, mm, ss, mss));
                            });
                        });
                    });
                });
            });
        });
    });
};
var parseYear = function (dictMonad) {
    return parseDateTimeSegment(dictMonad)(Data_Date_Component.boundedEnumYear)("bad year")(4);
};
var parseDate = function (dictMonad) {
    var parseMonth1 = parseMonth(dictMonad);
    var parseDay1 = parseDay(dictMonad);
    var maybeFail1 = maybeFail(dictMonad);
    return bind1(parseYear(dictMonad))(function (year) {
        return bind1(Parsing_String["char"]("-"))(function () {
            return bind1(parseMonth1)(function (month) {
                return bind1(Parsing_String["char"]("-"))(function () {
                    return bind1(parseDay1)(function (day) {
                        return maybeFail1("bad date")(Data_Date.exactDate(year)(month)(day));
                    });
                });
            });
        });
    });
};
var parseFullDateTime = function (dictMonad) {
    var parsePartialTime1 = parsePartialTime(dictMonad);
    var parseOffset1 = parseOffset(dictMonad);
    return bind1(parseDate(dictMonad))(function (date) {
        return bind1(choice([ Parsing_String["char"]("T"), Parsing_String["char"]("t") ]))(function () {
            return bind1(parsePartialTime1)(function (time) {
                return bind1(parseOffset1)(function (offset) {
                    return pure1(new FullDateTime(new Data_DateTime.DateTime(date, time), offset));
                });
            });
        });
    });
};
var parseFullDateTime1 = /* #__PURE__ */ parseFullDateTime(Data_Identity.monadIdentity);
var fromString = function (s) {
    return Parsing.runParser(s)(parseFullDateTime1);
};
export {
    Plus,
    Minus,
    Zulu,
    Offset,
    FullDateTime,
    parseFullDateTime,
    fromString,
    toUTC,
    showOffset,
    eqOffset,
    showDirection,
    eqDirection,
    showFullDateTime,
    eqFullDateTime
};
//# sourceMappingURL=index.js.map
